import { addDays, isToday } from "date-fns";
import { CalendarX2 } from "lucide-react";
import { APPT_STATUSES, dateKey, fmtRo, timeOf } from "@/lib/cal";
import { cn } from "@/lib/utils";

const STATUS_CLS = {
  programat: "text-blue-600 dark:text-blue-400 border-blue-500/30 bg-blue-500/10",
  finalizat: "text-emerald-600 dark:text-emerald-400 border-emerald-500/30 bg-emerald-500/10",
  anulat: "text-muted-foreground border-border bg-muted line-through",
};

export const ApptStatusBadge = ({ status }) => (
  <span className={cn("inline-flex whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold", STATUS_CLS[status])}>
    {APPT_STATUSES.find((s) => s.value === status)?.label}
  </span>
);

const Row = ({ a, color, onEvent }) => (
  <button onClick={() => onEvent(a)} data-testid={`agenda-appt-${a.id}`}
    className="grid w-full grid-cols-[88px_1fr] items-center gap-3 rounded-lg border bg-card p-3 text-left transition-colors hover:border-primary/50 sm:grid-cols-[100px_1fr_auto]">
    <span className="font-mono text-sm font-semibold">{timeOf(a.start)}–{timeOf(a.end)}</span>
    <div className="min-w-0">
      <div className="truncate font-semibold">{a.service_name}{a.client_name && <span className="font-normal text-muted-foreground"> · {a.client_name}</span>}</div>
      <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <span className="h-2 w-2 rounded-full" style={{ backgroundColor: color }} />{a.staff_name}
      </div>
    </div>
    <div className="col-span-2 sm:col-span-1"><ApptStatusBadge status={a.status} /></div>
  </button>
);

export const AgendaView = ({ weekStart, appts, staffById, onEvent }) => {
  const days = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
  if (!appts.length)
    return (
      <div className="rounded-xl border border-dashed py-16 text-center" data-testid="agenda-empty">
        <CalendarX2 className="mx-auto h-10 w-10 text-muted-foreground" />
        <p className="mt-3 font-semibold">Nicio programare în această săptămână</p>
      </div>
    );
  return (
    <div className="space-y-6" data-testid="agenda-view">
      {days.map((d) => {
        const list = appts.filter((a) => a.start.startsWith(dateKey(d)));
        if (!list.length) return null;
        return (
          <div key={dateKey(d)}>
            <h3 className={cn("mb-2 text-sm font-semibold uppercase tracking-wider text-muted-foreground", isToday(d) && "text-primary")}>
              {fmtRo(d, "EEEE, d MMMM")} <span className="font-normal">· {list.length}</span>
            </h3>
            <div className="space-y-2">{list.map((a) => <Row key={a.id} a={a} color={staffById[a.staff_id]?.color} onEvent={onEvent} />)}</div>
          </div>
        );
      })}
    </div>
  );
};
